<template>
  <div id="moblie" :class="currentPath == 'home' ? 'main' : ''">
    <template v-if="deviceType == 'wx' || deviceType == 'qq'">
      <div class="maskup">
        <div class="wixinDirection" @click="copy()">
          <p class="mr0">请点击复制</p>
          <p class="mr0">“<span class="link">在浏览器中打开</span>”</p>
        </div>
        <div class="fingerWrap moveAnimate">
          <img
            src="@/assets/img/moblie/finger.png"
            class="finger popingAnimate"
            alt="finger"
          />
        </div>
        <!--toast弹窗-->
        <div class="toast" v-show="toastShow">
          {{ toastText }}
        </div>
      </div>
    </template>
    <router-view></router-view>
  </div>
</template>
<script>
import { setTimeout } from "timers";
export default {
  name: "moblie",
  props: {
    deviceType: {
      type: String,
      default: "android",
    },
  },
  data() {
    return {
      currentPath: "",
      toastShow: false,
      toastText: "",
    };
  },
  watch: {
    $route: function (to, from) {
      this.currentPath = this.$route.name;
    },
  },
  methods: {
    toast(msg) {
      let self = this;
      self.toastText = msg;
      self.toastShow = true;
      setTimeout(function () {
        self.toastShow = false;
      }, 1500);
    },
    copy() {
      var message = window.location.href;
      var input = document.createElement("input");
      input.value = message;
      document.body.appendChild(input);
      input.setAttribute("readonly", "readonly");
      input.select();
      input.setSelectionRange(0, input.value.length),
        document.execCommand("Copy");
      this.toast("复制成功");
    },
  },
};
</script>
<style lang="scss">
@import "../assets/style/moblie.scss";
</style>